//#region IMPORT
import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { NavBarInfoActions } from '../../../Reducer/NavBarInfoReducer';
import { CommonActions } from '../../../Reducer/CommonReducer';
import M_MET_BASIC from './M_MET_BASIC';
import { useSearch2, useSearch3 } from './M_MET_BASIC_Query';
//#endregion

function M_MET_BASICF() {
  const dispatch = useDispatch();
  const searchInfo = useSelector((state) => state.searchInfo);

  const [rowData1, setRowData1] = useState([]);
  const [rowData2, setRowData2] = useState([]);
  const [value, setValue] = useState(0);

  const { runAsync: Search2Async } = useSearch2({
    onSuccess: (rows) => {
      setRowData1((rows ?? []).map((i) => ({ ...i, prefix: 'C' })));
    },
  });
  const { runAsync: Search3Async } = useSearch3({
    onSuccess: (rows) => {
      setRowData2((rows ?? []).map((i) => ({ ...i, prefix: 'I' })));
    },
  });

  const SearchLogic1 = async () => {
    if (value === 0) {
      await Search2Async();
    } else {
      await Search3Async();
    }
  };

  useEffect(() => {
    dispatch(NavBarInfoActions.setType('titleBar'));
    dispatch(NavBarInfoActions.setTitleName('회의록'));
    dispatch(CommonActions.setActiveStep(0));
  }, [dispatch]);

  useEffect(() => {
    SearchLogic1();
    // Search2Async, Search3Async는 훅 반환값이라 의존성에서 제외 (참조 변경 시 무한루프 방지)
  }, [value, searchInfo]);

  return (
    <div className="wrap">
      <M_MET_BASIC
        rowData1={rowData1}
        rowData2={rowData2}
        value={value}
        setValue={setValue}
      />
    </div>
  );
}

export default M_MET_BASICF;
